import { render, staticRenderFns } from "./SourceStatisticCard.vue?vue&type=template&id=573b53ce"
import script from "./SourceStatisticCard.vue?vue&type=script&lang=js"
export * from "./SourceStatisticCard.vue?vue&type=script&lang=js"
import style0 from "./SourceStatisticCard.vue?vue&type=style&index=0&id=573b53ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports